import { render, staticRenderFns } from "./BcbCampaignCustomerList.vue?vue&type=template&id=dae61b76&scoped=true"
import script from "./BcbCampaignCustomerList.vue?vue&type=script&lang=js"
export * from "./BcbCampaignCustomerList.vue?vue&type=script&lang=js"
import style0 from "./BcbCampaignCustomerList.vue?vue&type=style&index=0&id=dae61b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae61b76",
  null
  
)

export default component.exports